'use client';

import ResponsiveImage from '@/components/ui/ResponsiveImage';
import { useLanguage } from '@/lib/i18n/LanguageContext';

interface Speaker {
  id: string;
  last_name: string | null;
  first_name: string | null;
  middle_name: string | null;
  full_name: string;
  bio: string | null;
  photo_url: string | null;
}

interface EventSpeakersDisplayProps {
  speakers: Speaker[];
}

export default function EventSpeakersDisplay({ speakers }: EventSpeakersDisplayProps) {
  const { t } = useLanguage();

  if (!speakers || speakers.length === 0) {
    return null; // Hide section entirely if no speakers
  }

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('event.tabs.speakers') || 'Speakers'}</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {speakers.map((speaker) => (
          <div key={speaker.id} className="flex flex-col items-center text-center">
            {/* Circular Photo - 80px */}
            <div className="mb-4">
              <ResponsiveImage
                src={speaker.photo_url}
                alt={speaker.full_name}
                variant="avatar"
                size="xl"
                ring="default"
              />
            </div>

            {/* Full Name */}
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              {speaker.full_name}
            </h3>

            {/* Bio - Short Resume */}
            {speaker.bio?.trim() && (
              <p className="text-sm font-normal text-gray-600">
                {speaker.bio}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
